import styles from './Loader.module.scss'

export const SpinningCircle = () => (
  <div className={styles['spinning-circle']} />
)
